import { Component } from '@angular/core';

@Component({
  selector: 'app-cards11-examples-70',
  templateUrl: './cards11-examples-70.component.html'
})
export class Cards11Examples70Component {}
